import React, { useEffect, useState } from "react";
import Menu from "antd/lib/menu";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import { Link } from "react-router-dom"; // Import Link

import "./SideMenu.scss";
import {
  BarChartOutlined,
  HomeOutlined,
  ImportOutlined,
  RiseOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import { ENV } from "../config";
import { reset } from "../store/rootStore";
import { useDispatch, useSelector } from "react-redux";
import { encrypt } from "../utility";

const { SubMenu } = Menu;

const SideMenu = ({ collapsed, resMenuToggle, setResMenuToggle }) => {
  const userRole = useSelector((state) => state.rootStore.userRole);
  const storeId = useSelector((state) => state.rootStore.storeId);
  const [routeName, setRouteName] = useState("/");
  const [openKeys, setOpenKeys] = useState([]);
  const dispatch = useDispatch();
  const integrateKra = useSelector(
    (state) => state.rootStore.userProfileValues.integrateKra
  );

  useEffect(() => {
    setRouteName(window?.location?.pathname);
  }, []);

  useEffect(() => {
    getAllPermissions();
  }, []);

  const getAllPermissions = () => {
    let ls_role = userRole.toLowerCase();
    let data = {
      ls_role: ls_role,
      storeId: storeId,
    };
    // dispatch(setPermisssion(data));
  };

  const rootSubmenuKeys = ["1", "2", "3", "4", "6", "7"]; // Keys of all SubMenus

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => !openKeys.includes(key));

    if (rootSubmenuKeys.includes(latestOpenKey)) {
      // Only allow one SubMenu open at a time
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    } else {
      // If it's not a root submenu (like Menu.Item), keep the current openKeys
      setOpenKeys(keys);
    }
  };

  const clickHandler = () => {
    dispatch(reset());
    window.location.href = ENV.HOME_URL;
  };

  const logisticsClickHandler = async () => {
    let ls_logisticsUrl = ENV.LOGISTICS_URL;

    // if (storeId) {
    //   const encrypted = await encrypt(String(storeId));
    //   const lo_url = new URL(ENV.LOGISTICS_URL);
    //   lo_url.searchParams.set("store", encodeURIComponent(encrypted));
    //   ls_logisticsUrl = lo_url.toString();
    // }

    dispatch(reset());
    window.location.href = ls_logisticsUrl;
  };

  return (
    <div
      className={`side-menu-scroller h-full min-h-0 overflow-x-hidden overflow-y-auto fixed xl:static top-0 left-0 z-50 bg-white -translate-x-full xl:!translate-x-0 transition-all duration-300 ${collapsed ? "w-[80px] xl:w-[5%] flex flex-col items-center" : "w-full md:w-[300px] xl:w-[18%]"
        } ${resMenuToggle ? " translate-x-0" : ""}`}
    >
      <div className="p-3 bg-white xl:hidden">
        <button
          className="text-xl"
          type="button"
          onClick={() => setResMenuToggle(!resMenuToggle)}
        >
          <CloseOutlined />
        </button>
      </div>

      <Menu
        defaultSelectedKeys={["0"]}
        openKeys={collapsed ? [] : openKeys}
        onOpenChange={onOpenChange}
        mode="inline"
        inlineCollapsed={collapsed}
        className={`!border-0 transition-all duration-300 ${collapsed ? "px-0 items-center" : ""
          }`}
      >
        <Menu.Item
          key="5"
          onClick={() => clickHandler()}
          icon={<HomeOutlined style={{ color: "purple", fontSize: 16, strokeWidth: "35", stroke: "purple" }} />}
          className={"in-active"}
        >
          <span className="text-purple-800 font-bold font-size text-[16px]">
            Back to Home
          </span>
        </Menu.Item>

        {/* {ENV.REACT_APP_ENVIRONMENT !== "production" && ( */}
          <Menu.Item
            key="7"
            onClick={() => logisticsClickHandler()}
            icon={<SwapOutlined style={{ color: "purple", fontSize: 16, strokeWidth: "35", stroke: "purple" }} />}
            className={"in-active"}
          >
            <span className="text-purple-800 font-bold font-size text-[16px]">
              Logistics
            </span>
          </Menu.Item>
        {/* )} */}

        {/* <Menu.Item
          key="1"
          icon={
            <ShoppingCartOutlined style={{ color: "gray", fontSize: 15 }} />
          }
          className={`${routeName === "/" ? "active" : "in-active"} ${
            collapsed ? "flex justify-center" : ""
          }`}
        >
          <Link to="/">Purchase</Link>
        </Menu.Item>

        <Menu.Item
          key="3"
          icon={<ImportOutlined style={{ color: "gray", fontSize: 15 }} />}
          className={`${routeName === "/import" ? "active" : "in-active"} ${
            collapsed ? "flex justify-center" : ""
          }`}
        >
          <Link to="/imports">Imports</Link>
        </Menu.Item> */}
        {userRole !== "super admin" && (
          <>
            {integrateKra == "Yes" && ENV.REACT_APP_ENVIRONMENT !== "production" && (
              <SubMenu
                key="1"
                title="ETIMs Purchases"
                style={
                  !collapsed ? { marginLeft: "9px" } : { marginTop: "5px" }
                }
                icon={
                  <ShoppingCartOutlined
                    style={{ color: "gray", fontSize: 16, strokeWidth: "35", }}
                  />
                }
              >
                <Menu.Item key="1.1">
                  <Link to="/">ETIMs Purchase </Link>
                </Menu.Item>
                <Menu.Item key="1.2">
                  <Link to="/imports">ETIMs Imports</Link>
                </Menu.Item>
              </SubMenu>
            )}

            <SubMenu
                key="2"
                title="Transfer Management"
                style={!collapsed ? { marginLeft: "9px" } : { marginTop: "5px" }}
                icon={<SwapOutlined style={{ color: "gray", fontSize: 16, strokeWidth: "35", }} />}
              >
                <Menu.Item key="2.1">
                  <Link to="/incoming-transfer">Incoming Transfer</Link>
                </Menu.Item>
                <Menu.Item key="2.2">
                  <Link to="/outgoing-transfer">Outgoing Transfer</Link>
                </Menu.Item>
            </SubMenu>

            <SubMenu
              key="3"
              title="Stock Management"
              style={!collapsed ? { marginLeft: "9px" } : { marginTop: "5px" }}
              icon={
                <BarChartOutlined style={{ color: "gray", fontSize: 16, strokeWidth: "35", }} />
              }
            >
              <Menu.Item key="3.1">
                <Link to="/stock-analysis">Stock Analysis</Link>
              </Menu.Item>
              <Menu.Item key="3.2">
                <Link to="/stock-movement">Stock Movement</Link>
              </Menu.Item>
              {/* <Menu.Item key="3.3">
            <Link to="/stock-reorder">Stock Reorder</Link>
          </Menu.Item> */}
            </SubMenu>
            
            {/* {ENV.REACT_APP_ENVIRONMENT !== "production" && (
            )} */}
              <SubMenu
                key="4"
                title="Purchase Order"
                icon={<ShoppingCartOutlined style={{ color: "gray", fontSize: 16, strokeWidth: "35" }} />}
                style={!collapsed ? { marginLeft: "9px" } : { marginTop: "5px" }}
              >
                <Menu.Item key="4.1">
                  <Link to="/buying-leads">Buying Leads</Link>
                </Menu.Item>
                <Menu.Item key="4.2">
                  <Link to="/selling-leads">Selling Leads</Link>
                </Menu.Item>
              </SubMenu>

            {ENV.REACT_APP_ENVIRONMENT !== "production" && (
              <SubMenu
                key="6"
                title="Warehouse Management"
                icon={<ShopOutlined style={{ color: "gray", fontSize: 16, strokeWidth: "35" }} />}
                style={!collapsed ? { marginLeft: "9px" } : { marginTop: "5px" }}
              >
                <Menu.Item key="6.1">
                  <Link to="/warehouse">WareHouses</Link>
                </Menu.Item>
                <Menu.Item key="6.2">
                  <Link to="/zone">Zones</Link>
                </Menu.Item>
                <Menu.Item key="6.3">
                  <Link to="/aisle">Aisles</Link>
                </Menu.Item>
                <Menu.Item key="6.4">
                  <Link to="/shelf">Shelves</Link>
                </Menu.Item>
                <Menu.Item key="6.5">
                  <Link to="/bin">Bin</Link>
                </Menu.Item>
              </SubMenu>
            )}

            {ENV.REACT_APP_ENVIRONMENT !== "production" && (
              <Menu.Item
                key="8"
                icon={<ShopOutlined style={{ color: "gray", fontSize: 16, strokeWidth: "35" }} />}
                className="in-active"
              >
                <Link to="/warehouse-inventory">Warehouse Inventory</Link>
              </Menu.Item>
            )}
            
            {/* <Menu.Item
          key="4"
          icon={<BarChartOutlined style={{ color: "gray", fontSize: 15 }} />}
          className={`${
            routeName === "/stock-analysis" ? "active" : "in-active"
          } ${collapsed ? "flex justify-center" : ""}`}
        >
          <Link to="/stock-analysis">Stock Analysis</Link>
        </Menu.Item>
        <Menu.Item
          key="6"
          icon={<RiseOutlined style={{ color: "gray", fontSize: 15 }} />}
          className={`${
            routeName === "/stock-movement" ? "active" : "in-active"
          } ${collapsed ? "flex justify-center" : ""}`}
        >
          <Link to="/stock-movement">Stock Movement</Link>
        </Menu.Item> */}
          </>
        )}
      </Menu>
    </div>
  );
};

export default SideMenu;
